import { ArrowLeftSLine, Text } from '@bizzabo/design-system';
import { makeStyles } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';
import { useDrawerContentAtom } from '../../atoms';
import cn from 'clsx';
import { DrawerNav } from '../../DrawerContent/const';

type BackButtonProps = {
    buttonText: string;
    to: DrawerNav;
    className?: string;
};

const useStyles = makeStyles<Theme>(
    theme => ({
        headerSection: {
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'flex-start',
            margin: '26px 0',
            cursor: 'pointer',
            '&:hover $arrowBackIcon': {
                transform: 'translateX(-4px)',
            },
        },
        arrowBackIcon: {
            width: '2em',
            height: '2em',
            transition: 'transform 0.3s ease-out',
        },
        headerText: {
            paddingLeft: 8,
            color: theme.palette.greys[400],
            lineHeight: '115%',
        },
    }),
    { classNamePrefix: 'drawer-back-button' }
);

export const BackButton: React.FC<BackButtonProps> = ({ buttonText, to, className }) => {
    const classes = useStyles();
    const { setDrawerContent } = useDrawerContentAtom();
    const onNavigationClick = () => setDrawerContent(to);

    return (
        <div onClick={onNavigationClick} className={cn(classes.headerSection, className)}>
            <ArrowLeftSLine className={classes.arrowBackIcon} />
            <Text variant="t50" className={classes.headerText}>
                {buttonText}
            </Text>
        </div>
    );
};
